export default __webpack_public_path__ + "static/media/About-us.88da50ee.jpeg";